import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { DropdownWithValidationAndTooltip } from '../../../components/prime-formik';
import { Field, useFormikContext } from 'formik';

const messages = defineMessages({
  vatCountry: { id: 'attrs.vatCountry', defaultMessage: 'VAT/GST country' },
  vatCountryTooltipNoSelectedCountry: {
    id: 'attrs.vatCountry.tooltip-no-selected-country',
    defaultMessage: 'The country and format of the VAT/GST ID',
  },
  vatCountryTooltipWithSelectedCountry: {
    id: 'attrs.vatCountry.tooltip-with-selected-country',
    defaultMessage: 'Select the GST/VAT format of {selectedCountry}',
  },
});

const TaxIdTypeInput = ({ countries, availableTaxIds, taxIdOptions, setSelectedTaxId }) => {
  const { formatMessage } = useIntl();
  const { setFieldValue, values } = useFormikContext();

  const vatCountryTooltip = values.company.country
    ? formatMessage(messages.vatCountryTooltipWithSelectedCountry, {
        selectedCountry: countries.find((country) => country.value === values.company.country).label,
      })
    : formatMessage(messages.vatCountryTooltipNoSelectedCountry);

  return (
    <div className="p-col-12">
      <label className="field-label" htmlFor="company.taxIdType">
        <FormattedMessage id="attrs.vatCountry" defaultMessage="VAT/GST country" />
      </label>
      <Field
        id="company.taxIdType"
        name="company.taxIdType"
        labelText={formatMessage(messages.vatCountry)}
        filter
        filterBy="label,value"
        options={taxIdOptions}
        component={DropdownWithValidationAndTooltip}
        tooltipText={vatCountryTooltip}
        onChange={(e) => {
          setFieldValue('company.taxIdType', e.target.value);

          const taxInformation = availableTaxIds.find((availableTaxId) => availableTaxId.id === e.target.value);

          if (taxInformation) {
            setSelectedTaxId(taxInformation);
          }
        }}
      />
    </div>
  );
};

export default TaxIdTypeInput;
